module.exports = __webpack_public_path__ + "img/52.10.pH.bf2f203a.png";